<i18n>
{
  "en": {
    "title": "Order Info",
    "pleaseEnterPhoneNumber": "Please enter phone number"
  },
  "zh-tw": {
    "title": "訂單資訊",
    "pleaseEnterPhoneNumber": "請輸入手機號碼"
  }
}
</i18n>

<template>
  <prompt
    :title="$t(`title`)"
    :label="$t(`pleaseEnterPhoneNumber`)"
    :defaultValue="phoneNumber"
    inputType="number"
    :validator="validator"
    placeholder="ex. 0912345678"
    @confirm="v => setOrderParams({ phoneNumber: v })" />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Prompt from '@/common/components/Prompt'
import { validatePhoneNumber } from '@/common/helpers/validators'

export default {
  computed: {
    ...mapState(['phoneNumber']),
    validator () {
      return validatePhoneNumber
    }
  },
  methods: {
    ...mapActions(['setOrderParams'])
  },
  components: { Prompt }
}
</script>
